import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
function ApplePodcastsIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" data-id="element-61">
      <path d="M12 2a8 8 0 0 0-4.9 14.32.6.6 0 0 0 .95-.6.6.6 0 0 0-.23-.39 6.8 6.8 0 1 1 8.36 0 .6.6 0 0 0 .72.96A8 8 0 0 0 12 2Zm0 3.2a4.8 4.8 0 0 0-2.86 8.66.6.6 0 1 0 .72-.96 3.6 3.6 0 1 1 4.28 0 .6.6 0 1 0 .72.96A4.8 4.8 0 0 0 12 5.2Zm0 3.1a1.7 1.7 0 0 0-.7 3.25l-.62 5.2a1.33 1.33 0 0 0 2.64 0l-.62-5.2A1.7 1.7 0 0 0 12 8.3Z" data-id="element-62" />
    </svg>;
}
function SpotifyIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" data-id="element-63">
      <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm4.59 14.43a.62.62 0 0 1-.86.21c-2.35-1.44-5.3-1.76-8.79-.96a.62.62 0 1 1-.28-1.22c3.81-.87 7.08-.5 9.72 1.11.3.18.39.57.21.86Zm1.22-2.72a.78.78 0 0 1-1.07.26c-2.69-1.65-6.79-2.13-9.97-1.16a.78.78 0 1 1-.45-1.49c3.63-1.1 8.15-.57 11.24 1.32.37.22.49.7.25 1.07Zm.11-2.84c-3.23-1.92-8.55-2.1-11.63-1.16a.93.93 0 1 1-.54-1.78c3.54-1.07 9.42-.87 13.13 1.34a.93.93 0 1 1-.96 1.6Z" data-id="element-64" />
    </svg>;
}
function YoutubeIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" data-id="element-65">
      <path d="M23.5 6.5a3 3 0 0 0-2.12-2.12C19.5 3.86 12 3.86 12 3.86s-7.5 0-9.38.52A3 3 0 0 0 .5 6.5 31.3 31.3 0 0 0 0 12a31.3 31.3 0 0 0 .5 5.5 3 3 0 0 0 2.12 2.12c1.88.52 9.38.52 9.38.52s7.5 0 9.38-.52a3 3 0 0 0 2.12-2.12A31.3 31.3 0 0 0 24 12a31.3 31.3 0 0 0-.5-5.5ZM9.6 15.6V8.4l6.2 3.6-6.2 3.6Z" data-id="element-66" />
    </svg>;
}
export function FeaturedEpisodes() {
  const {
    t
  } = useLanguage();
  const episode = {
    number: '01',
    title: t('episodes.ep1.title'),
    description: t('episodes.ep1.desc'),
    image: 'https://cdn.magicpatterns.com/uploads/4mn5uPBDrLdbXU3SXiDbje/ChatGPT_Image_13_juin_2026,_20_40_56.png',
    duration: t('episodes.ep1.duration'),
    year: '2026',
    apple: 'https://podcasts.apple.com/sn/podcast/1-de-75-dollars-%C3%A0-20-milliards-de-dollars/id1888801055?i=1000772931355',
    spotify: 'https://open.spotify.com/episode/5JftV89vsWqNGSiY6Heu6x?si=mVsK4h_PRyemgZHUWPvFyQ',
    youtube: 'https://youtu.be/EJ1-aUykVpM?si=Q2UB4AkwTQHcwH3L'
  };
  const platforms = [{
    name: 'Apple Podcasts',
    href: episode.apple,
    Icon: ApplePodcastsIcon,
    hover: 'hover:bg-[#9933CC] hover:border-[#9933CC]'
  }, {
    name: 'Spotify',
    href: episode.spotify,
    Icon: SpotifyIcon,
    hover: 'hover:bg-[#1DB954] hover:border-[#1DB954]'
  }, {
    name: 'YouTube',
    href: episode.youtube,
    Icon: YoutubeIcon,
    hover: 'hover:bg-[#FF0000] hover:border-[#FF0000]'
  }];
  return <section id="episodes" className="py-24 px-6 md:px-12 bg-archival-cream relative scroll-mt-20" data-id="element-67">
      {/* Background Pattern Accent */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-pattern-geometric opacity-20 pointer-events-none" data-id="element-68" />

      <div className="max-w-7xl mx-auto" data-id="element-69">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 border-b-4 border-gold pb-8 relative" data-id="element-70">
          {/* Decorative Pattern Line */}
          <div className="absolute bottom-[-4px] left-0 w-1/3 h-1 bg-earth-terracotta z-10" data-id="element-71" />

          <div data-id="element-72">
            <span className="font-mono text-earth-terracotta text-sm tracking-widest uppercase mb-3 block font-bold" data-id="element-73">
              {t('episodes.collection')}
            </span>
            <h2 className="text-4xl md:text-6xl font-sans font-black text-charcoal-900" data-id="element-74">
              {t('episodes.selected')}{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-earth-ochre" data-id="element-75">
                {t('episodes.chapters')}
              </span>
            </h2>
          </div>
          <div className="mt-6 md:mt-0 font-mono text-charcoal-500 text-sm text-right" data-id="element-76">
            <p className="font-bold text-charcoal-900" data-id="element-77">{t('episodes.new')}</p>
            <p data-id="element-78">{t('episodes.available')}</p>
          </div>
        </div>

        {/* Full-width Episode Card */}
        <div className="group relative" data-id="element-79">
          {/* Card Background glow */}
          <div className="absolute -inset-2 bg-gradient-to-r from-gold/20 to-earth-terracotta/20 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-sm" data-id="element-80" />

          <div className="relative bg-white border border-charcoal-200 shadow-sm hover:shadow-xl transition-all duration-300 rounded-lg overflow-hidden grid grid-cols-1 lg:grid-cols-2" data-id="element-81">
            {/* Image */}
            <a href={episode.youtube} target="_blank" rel="noopener noreferrer" className="block relative aspect-video lg:aspect-auto lg:h-full overflow-hidden border-b-4 lg:border-b-0 lg:border-r-4 border-gold" data-id="element-82">
              <img src={episode.image} alt={episode.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" data-id="element-83" />
              <div className="absolute top-4 left-4 bg-charcoal-900 text-gold font-mono text-xs px-2 py-1 uppercase tracking-widest" data-id="element-84">
                Ep. {episode.number}
              </div>
              <div className="absolute bottom-0 right-0 bg-gold text-charcoal-900 font-mono text-xs px-3 py-1 font-bold" data-id="element-85">
                {episode.duration}
              </div>
            </a>

            {/* Content */}
            <div className="p-8 md:p-10 flex flex-col justify-center" data-id="element-86">
              <span className="font-mono text-earth-terracotta text-sm font-bold mb-3 block" data-id="element-87">
                {episode.year}
              </span>

              <h3 className="text-2xl md:text-3xl font-serif font-bold text-charcoal-900 mb-4" data-id="element-88">
                {episode.title}
              </h3>

              <p className="text-charcoal-600 font-serif leading-relaxed mb-8" data-id="element-89">
                {episode.description}
              </p>

              {/* Platform Icon Links */}
              <div className="flex items-center gap-4" data-id="element-90">
                <span className="font-mono text-xs uppercase tracking-widest text-charcoal-500 font-bold mr-1" data-id="element-91">
                  {t('episodes.listenOn')}
                </span>
                {platforms.map(({
                name,
                href,
                Icon,
                hover
              }) => <a key={name} href={href} target="_blank" rel="noopener noreferrer" aria-label={name} title={name} className={`w-11 h-11 flex items-center justify-center rounded-full border-2 border-charcoal-900 text-charcoal-900 transition-all duration-300 hover:text-white ${hover}`} data-id="element-92">
                    <Icon className="w-5 h-5" data-id="element-93" />
                  </a>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}